import { RTable } from "../../Component/Table/RTable";
import { TableStructure } from "../../Component/Table/TableStructureInterface";
import { PageHeader } from "../../Component/Common/Headers";
import { dateFormat } from "../../Helpers/commonFunction/commonFunction";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../Helpers/config/config";

export const ProgramList = () => {
    const tableStructure: TableStructure[] = [
        {
            name: "id", render: (data: any, index: any) => {
                return index;
            },
        },
        {
            name: "Name", render: (data: any, index: any) => {
                return data.name;
            },
        },
        { name: "Slug", key: "slug" },
        {
            name: "CreatedAt", render: (data: any, index: any) => {
                return dateFormat(data.createdAt);
            }
        },

        {
            name: "Action", render: (data: any, onDelete: any) => {
                return <div className="d-flex align-items-center justify-content-start gap-3">
                    <Link to={`/ProgramForm/${data.id}`}>
                        <img width="16px" src={PUBLIC_URL + "/images/edit.svg"} alt="edit" />
                    </Link>
                    <Link to="#" onClick={() => { onDelete(data.id) }}>
                        <img width="16px" src={PUBLIC_URL + "/images/delete.svg"} alt="delete" />
                    </Link>
                </div>;
            },
        },
    ];

    return (
        <div className="container">
            <PageHeader
                title="Program Management"
                subtitle="Configure programs"
            />
            <RTable xFileName="program_data" Addlink="/ProgramForm" deleteUrl="programs" api="programs/withPagination" tableStructure={tableStructure} />
        </div>
    );
};
